import React, { useState, useEffect } from "react";
import Controls from "../../../controls/Controls";
import {
  Paper,
  makeStyles,
  TableBody,
  TableRow,
  TableCell,
} from "@material-ui/core";
import useTable from "../../../utilities/useTable";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import BackArrow from "@material-ui/icons/ArrowBackIos";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { CLEAR_PAYMENTS_HISTORY } from "../../../../redux-store/reducers/actions/Constants";
import Popup from "../../../utilities/Popup";
import { FlashOnOutlined } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  pageContent: {
    margin: theme.spacing(1),
    padding: theme.spacing(3),
  },
  searchInput: {
    width: "75%",
  },
  newButton: {
    position: "absolute",
    right: "10px",
  },
}));

// Product Name, / Price / Quantity / Total

const headCells = [
  { id: "productName", label: "Product Name" },
  { id: "Price", label: "Price" },
  { id: "quantity", label: "Quantity" },
  { id: "total", label: "Total" },
  { id: "actions", label: "Actions", disableSorting: true },
];
const PaymentHistory = ({ payments, ClearPaymentHistory }) => {
  const classes = useStyles();
  const [openPopup, setOpenPopup] = useState(false);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const object = [
    {
      productName: "Bass Guiter",
      amount: 6000,
      quantity: 10,
      name: "Poise-Paul",
    },
  ];
  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(payments[0], headCells, filterFn);
    let total=0;

  return (
    <>
      <div>
        {" "}
        <Paper className={classes.pageContent}>
          <div className="grid grid-cols-2">
            <h4>
              {" "}
              <strong>Order History</strong>
            </h4>
            <div className="flex justify-end">
              <Link to="/payments" onClick={() => ClearPaymentHistory()}>
                <div className="flex space-x-2 items-center py-2 px-3 rounded-full bg-[#4f6cfe4a] transition duration-500 ease-in-out hover:bg-[#4f6cfe85]">
                  <BackArrow className="text-[#4f6bfe]" />
                  Back to Payments
                </div>
              </Link>
            </div>
          </div>

          <TblContainer>
            <TblHead />
            <TableBody>
              {recordsAfterPagingAndSorting().map((item) => (
             
                <>
                <input value={total+=item.totalAmount} type="hidden"/>
                  <TableRow key={item.id}>
                    <TableCell>{item.productName}</TableCell>
                    <TableCell>{item.amount}</TableCell>
                    <TableCell>{item.quantity}</TableCell>
                    <TableCell>{item.totalAmount}</TableCell>
                    <TableCell>
                      <Controls.ActionButton color="primary">
                        <EditOutlinedIcon
                          fontSize="small"
                          onClick={() => setOpenPopup(true)}
                        />
                      </Controls.ActionButton>
                    </TableCell>
                  </TableRow>
                </>
              ))}
            </TableBody>
            <div>
              {" "}
              <h2 className="text-2xl font-semibold ">
                {" "}
                Total Amount:{" "}
                <span className="text-[rgb(79,107,254)]">
                  ₦{total}
                </span>
              </h2>
            </div>
          </TblContainer>

          <TblPagination />
        </Paper>
      </div>

      <Popup
        title="Order Details"
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
      >
        Hello Dear
      </Popup>
    </>
  );
};

function mapStateToProps(state) {
  return {
    payments: state.paymentHistory,
  };
}
const mapDispatchToProps = (dispatch) => ({
  ClearPaymentHistory() {
    dispatch({ type: CLEAR_PAYMENTS_HISTORY });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(PaymentHistory);
